import { useEffect, useState } from "react";
import { Box, CardContent, Checkbox, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import MaterialButton from "../../../components/MaterialButton";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout/index.js";
import MaterialBox from "../../../components/MaterialBox/index.js";
import MaterialSelect from "../../../components/MaterialSelect/index.js";
import MaterialTypography from "../../../components/MaterialTypography/index.js";
import { fetchData, postData } from "../../Utils/Baseurl.js";
import { useLoading } from "../../../context/loadingcontext/index.js";
import { useSnackbar } from "../../../components/SnackbarProvider/index.js";

const RolePermission = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [role, setrole] = useState([]);
  const { setCirleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const [allRole, setAllRole] = useState("");

  const handleChanges = (e) => setAllRole(e);

  useEffect(() => {
    getRoleList();
  }, []);


  //   Get Role List

  const getRoleList = async () => {
    try {
      const response = await fetchData("api/roles/");

      if (response?.status && Array.isArray(response.data)) {
        setrole(response.data);
      } else {
        setrole([]);
      }
    } catch (error) {
      console.error("Error while fetching role list:", error);

      setrole([]);
    }
  };

  //createRole data
  const createRole = async () => {
    setCirleLoading(true);
    const data = filteredData.flatMap((module,) =>
      module.component.map((component,) => ({
        id: component.role_permission_id,
        role: allRole.value,
        app: module?.app_id,
        module: module?.module_id,
        component: component.component_id,
        can_access: component.Rolepermission,
      }))
    );

    try {
      let response = await postData("api/rolepermission/", data);

      if (response.status) {
        showSnackbar(response?.message, "success");
      } else {
        showSnackbar(response?.message, "error");
      }
    } catch (error) {
      console.log(error);

      let message = "An unexpected error occurred";

      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  // get all component data
  const getComponent = async (e) => {
    if (e) {
      setCirleLoading(true);
      const data = {
        role_id: e.value,
      };
      try {
        const response = await postData(`api/componentlist/`, data);

        if (response?.status && Array.isArray(response.data)) {
          setFilteredData(response.data);
        } else {
          setrole([]);
        }
      } catch (error) {
        console.error("Error while fetching role list:", error);
      } finally {
        setCirleLoading(false);
      }
    }
  };

  // onCheck function
  const handleCheck = (componentInd, module, moduleInd) => {
    const updatedData = filteredData.map((mod, modIndex) => {
      if (modIndex === moduleInd) {
        return {
          ...mod,
          component: mod.component.map((comp, compIndex) => {
            if (compIndex === componentInd) {
              return {
                ...comp,
                Rolepermission: !comp.Rolepermission,
              };
            }
            return comp;
          }),
        };
      }
      return mod;
    });

    setFilteredData(updatedData);
  };
  const handleCheckAll = () => {
    const allChecked = filteredData.every((module) =>
      module.component.every((comp) => comp.Rolepermission)
    );

    const updatedData = filteredData.map((module) => ({
      ...module,
      component: module.component.map((comp) => ({
        ...comp,
        Rolepermission: !allChecked,
      })),
    }));

    setFilteredData(updatedData);
  };
  const handleModuleCheck = (moduleInd) => {
    const allChecked = filteredData[moduleInd].component.every(
      (comp) => comp.Rolepermission
    );

    const updatedData = filteredData.map((module, modIndex) => {
      if (modIndex === moduleInd) {
        return {
          ...module,
          component: module.component.map((comp) => ({
            ...comp,
            Rolepermission: !allChecked,
          })),
        };
      }
      return module;
    });

    setFilteredData(updatedData);
  };

 

  return (
    <DashboardLayout>
      <Box sx={{ padding: "10px" }}>
        <Box sx={{ width: "50%", marginBottom: "15px" }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ fontFamily: "initial", fontSize: "16px" }}
            >
              Roll Name <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialSelect
            name="role"
            value={allRole}
            onChange={(e) => {
              handleChanges(e);
              getComponent(e);
            }}
            options={role?.map((role) => ({
              value: role.id,
              label: role.role,
            }))}
            isClearable
          />
        </Box>

        <Box>
          {allRole?.value && (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  padding: "0px 70px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    sx={{
                      fontWeight: "600",
                      color: "#3F51B5d4",
                      marginRight: "10px",
                      fontSize: "16px",
                      fontFamily: "initial",
                    }}
                  >
                    Select All
                  </Typography>
                  <Checkbox
                    onChange={handleCheckAll}
                    checked={
                      filteredData.length > 0 &&
                      filteredData.every((module) =>
                        module.component.every((comp) => comp.Rolepermission)
                      )
                    }
                    sx={{
                      color: "#424242",
                      "&.Mui-checked": { color: "#1976d2" },
                      "& .MuiSvgIcon-root": {
                        fontSize: "18px",
                        border: "1px solid #424242",
                        borderRadius: "4px",
                      },
                    }}
                  />
                </Box>
              </Box>
              {/* <Grid container spacing={2}>
                {filteredData.map((app, appInd) => (
                  <CardContent key={appInd}>
                    <Grid item xs={12} sm={6} md={4} key={appInd}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          sx={{
                            fontWeight: "600",
                            color: "#3F51B5d4",
                            fontSize: "16px",
                            marginRight: "10px",
                            width:"600px"
                          }}
                        >
                          {app.module_name}
                        </Typography>
                        <Checkbox
                          onChange={() => handleModuleCheck(appInd)}
                          checked={app.component.some(
                            (comp) => comp.Rolepermission
                          )}
                          sx={{
                            color: "#424242",
                            "&.Mui-checked": { color: "#1976d2" },
                            "& .MuiSvgIcon-root": {
                              fontSize: "18px",
                              border: "1px solid #424242",
                              borderRadius: "4px",
                            },
                          }}
                        />
                      </Box>
                      {app.component.map((component, compInd) => (
                        <Box
                          key={compInd}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            margin: "10px 0px",
                          }}
                        >
                          <Checkbox
                            checked={component?.Rolepermission}
                            onChange={() => handleCheck(compInd, app, appInd)}
                            sx={{
                              color: "#424242",
                              "&.Mui-checked": { color: "#1976d2" },
                              "& .MuiSvgIcon-root": {
                                fontSize: "18px",
                                border: "1px solid #424242",
                                borderRadius: "4px",
                              },
                            }}
                          />
                          <Typography variant="body1" sx={{ fontSize: "15px" }}>
                            {component.component_name}
                          </Typography>
                        </Box>
                      ))}
                    </Grid>
                  </CardContent>
                ))}
              </Grid> */}

              <Grid container spacing={2}>
                {filteredData.map((app, appInd) => (
                  <Grid item xs={12} sm={6} md={3} key={appInd}>
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            color: "#3F51B5d4",
                            fontSize: "16px",
                            marginRight: "10px",
                            // width: "50%",
                            fontFamily: "initial",
                          }}
                        >
                          {app.module_name}
                        </Typography>
                        <Checkbox
                          onChange={() => handleModuleCheck(appInd)}
                          checked={app.component.every(
                            (comp) => comp.Rolepermission
                          )}
                          sx={{
                            color: "#424242",
                            "&.Mui-checked": { color: "#1976d2" },
                            "& .MuiSvgIcon-root": {
                              fontSize: "18px",
                              border: "1px solid #424242",
                              borderRadius: "4px",
                            },
                          }}
                        />
                      </Box>

                      {/* Component checkboxes */}
                      {app.component.map((component, compInd) => (
                        <Box
                          key={compInd}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            margin: "10px 0px",
                          }}
                        >
                          <Checkbox
                            checked={component?.Rolepermission}
                            onChange={() => handleCheck(compInd, app, appInd)}
                            sx={{
                              color: "#424242",
                              "&.Mui-checked": { color: "#1976d2" },
                              "& .MuiSvgIcon-root": {
                                fontSize: "18px",
                                border: "1px solid #424242",
                                borderRadius: "4px",
                              },
                            }}
                          />
                          <Typography
                            variant="body1"
                            sx={{ fontSize: "15px", fontFamily: "initial" }}
                          >
                            {component.component_name}
                          </Typography>
                        </Box>
                      ))}
                    </CardContent>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            {allRole?.value && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={createRole}
              >
                Submit
              </MaterialButton>
            )}
          </Box>
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default RolePermission;
